<div
  class="fms-notification-item"
  [class.fms-notification-item--unread]="isUnread"
  role="listitem"
  tabindex="0"
  (click)="onRowClick()"
  (keyup.enter)="onRowClick()"
>
  <div class="fms-notification-item__category" [attr.aria-label]="categoryUi.label">
    <vng-icon [name]="categoryUi.icon" [outline]="false" color="inherit"></vng-icon>
    <span>{{ categoryUi.label }}</span>
  </div>

  <div class="fms-notification-item__body" [ngSwitch]="rendererKind">
    <app-notification-link-renderer
      *ngSwitchCase="'link'"
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-link-renderer>
    <app-notification-image-renderer
      *ngSwitchCase="'image'"
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-image-renderer>
    <app-notification-video-renderer
      *ngSwitchCase="'video'"
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-video-renderer>
    <app-notification-actions-renderer
      *ngSwitchCase="'actions'"
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-actions-renderer>
    <app-notification-survey-renderer
      *ngSwitchCase="'survey'"
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-survey-renderer>
    <app-notification-text-renderer
      *ngSwitchDefault
      [template]="notification.template"
      (respond)="onRespond($event)"
    ></app-notification-text-renderer>
  </div>

  <div class="fms-notification-item__meta">
    <span class="fms-notification-item__time">{{ relativeTime }}</span>
    <button
      vng-icon-button
      [small]="true"
      type="button"
      aria-label="Dismiss notification"
      (click)="onDismissClick($event)"
    >
      <vng-icon name="close" [outline]="false" color="inherit"></vng-icon>
    </button>
  </div>
</div>
